/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DeviceEventType = {
    WeightRead: 'weight_read',
    CaptureComplete: 'capture_complete',
    AppStart: 'app_start',
    AppStop: 'app_stop',
    ImuRead: 'imu_read',
    ImuTap: 'imu_tap',
    ImuTapSequenceComplete: 'imu_tap_sequence_complete',
    GpsFix: 'gps_fix',
    Sysinfo: 'sysinfo',
    Tare: 'tare',
    ClockShift: 'clock_shift',
    CalibrationSaved: 'calibration_saved',
    SignsSaved: 'signs_saved',
    CaptureTriggered: 'capture_triggered',
    DataPushComplete: 'data_push_complete',
    CameraError: 'camera_error',
    WifiStatusChange: 'wifi_status_change',
    WifiClientChange: 'wifi_client_change',
    ManualCaptureLogged: 'manual_capture_logged',
    ConfigChanged: 'config_changed',
    SessionIntent: 'session_intent',
    ErrorStateEntered: 'error_state_entered',
    ErrorStateCleared: 'error_state_cleared',
    Unknown: 'unknown',
} as const;
export type DeviceEventType = typeof DeviceEventType[keyof typeof DeviceEventType];


export function instanceOfDeviceEventType(value: any): boolean {
    for (const key in DeviceEventType) {
        if (Object.prototype.hasOwnProperty.call(DeviceEventType, key)) {
            if (DeviceEventType[key as keyof typeof DeviceEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DeviceEventTypeFromJSON(json: any): DeviceEventType {
    return DeviceEventTypeFromJSONTyped(json, false);
}

export function DeviceEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceEventType {
    return json as DeviceEventType;
}

export function DeviceEventTypeToJSON(value?: DeviceEventType | null): any {
    return value as any;
}

export function DeviceEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DeviceEventType {
    return value as DeviceEventType;
}

